(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('MoneyTransferLog', MoneyTransferLog);

    MoneyTransferLog.$inject = ['$resource', 'DateUtils'];

    function MoneyTransferLog($resource, DateUtils) {
        var resourceUrl = 'api/money-transfer-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                        data.transferDate = DateUtils.convertDateTimeFromServer(data.transferDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
